import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormBuilder, UntypedFormControl } from "@angular/forms";
import { MatSidenav } from "@angular/material/sidenav";
import {
  ofActionErrored,
  ofActionSuccessful,
  Select,
  Store,
} from "@ngxs/store";
import { Observable, Subject, Subscription } from "rxjs";
import {
  debounceTime,
  distinctUntilChanged,
  skipWhile,
  tap,
} from "rxjs/operators";
import { ResultSearchCriteria, Tag } from "src/app/interface/product";
import { DataService } from "src/app/services/data.service";
import {
  AddCriteriaSearch,
  CreateSearchCriteria,
  DeleteSearchCriteriaUser,
  FindProductFeatures,
  FindSearchCriteria,
  GetTagsForMarketSearch,
  ProductsByTag,
  ResetFinds,
  SetProductTag,
  TagsByFather,
} from "src/app/states/actions/product.actions";
import { ProductsState } from "src/app/states/product.state";
import { UIState } from "src/app/states/ui.state";

@Component({
  selector: "app-search",
  templateUrl: "./search.component.html",
  styleUrls: ["./search.component.less"],
})
export class SearchComponent implements OnInit {
  @Select(ProductsState.findsFiltered)
  findsFiltered: Observable<ResultSearchCriteria>;
  @Select(ProductsState.tagsFiltered) tagsFiltered: Observable<Tag[]>;
  @ViewChild("searchInput", { static: true }) searchInput;
  @Input() store: Store;
  @Input() drawer: MatSidenav;
  @Input() utilities: { actions: any; store: Store };
  criteria: UntypedFormControl;
  searchTagsSubs: Subscription;
  searchCriteriaSubs: Subscription;
  searchCriteria = new Subject<string>();
  constructor(
    private fb: UntypedFormBuilder,
    private _dataService: DataService
  ) {}

  ngOnInit() {
    this.criteria = this.fb.control("");
    this.searchTagsSubs = this.searchCriteria
      .pipe(
        skipWhile((val) => val.trim() === ""),
        debounceTime(400),
        distinctUntilChanged(),
        tap((x) => {
          if (x.trim() !== "") {
            this.utilities.store.dispatch(
              new GetTagsForMarketSearch(this.criteria.value.trim())
            );
          }
        })
      )
      .subscribe();
    this.searchCriteriaSubs = this.searchCriteria
      .pipe(
        skipWhile((val) => val.trim() === ""),
        debounceTime(400),
        distinctUntilChanged(),
        tap((x) => {
          if (x.trim() !== "") {
            this.utilities.store.dispatch(
              new FindSearchCriteria(this.criteria.value.trim())
            );
          }
        })
      )
      .subscribe();
  }

  searchByFind = (criteria) => {
    this._dataService.displayLoading();
    if (criteria && criteria !== "") {
      this.handler(FindProductFeatures);
      this.utilities.store.dispatch(
        new AddCriteriaSearch({ type: "criteria", criteria })
      );
    }
    this.utilities.store.dispatch(new ResetFinds());
    this.handler(ResetFinds);
    setTimeout(() => {
      if (this.searchInput) {
        this.searchInput.nativeElement.blur();
      }
    }, 500);
  };

  searchProduct = (criteria) => {
    this._dataService.displayLoading();
    this.utilities.store.dispatch(new ResetFinds());
    if (criteria && criteria !== "") {
      this.handler(FindProductFeatures);
      this.utilities.store.dispatch(
        new AddCriteriaSearch({ type: "criteria", criteria })
      );
    }
    this.handler(ResetFinds);
    this.handler(CreateSearchCriteria);
  };

  searchByTag = (tag, needFind) => {
    this._dataService.displayLoading();
    if (tag && tag.id !== "Categorías") {
      const newTag = needFind ? needFind.find((t) => t.id === tag.id) : tag;
      this.criteria.setValue(newTag.Value);
      this.handler(ProductsByTag);
      this.utilities.store.dispatch(
        new AddCriteriaSearch({
          type: "tag",
          criteria: newTag.id,
          tag: newTag.Value,
        })
      );
      this.handler(CreateSearchCriteria);
      this.utilities.store.dispatch(new SetProductTag(tag));
      if (newTag && newTag.TagCategory && newTag.TagCategory.id !== "3") {
        this.handler(TagsByFather);
        this.utilities.store.dispatch(new TagsByFather(newTag.id, false));
      }
      this.utilities.store.dispatch(new ResetFinds());
      setTimeout(() => {
        if (this.searchInput) {
          this.searchInput.nativeElement.blur();
        }
      }, 500);
    }
  };

  focus = (event) => {
    event.focus();
    if (event.value && event.value !== "") {
      this.searchByFind(event.value);
      event.blur();
    }
  };

  handler = (action) => {
    let errorSubs;
    let subs;
    errorSubs = this.utilities.actions
      .pipe(ofActionErrored(action))
      .subscribe(() => {
        this._dataService.displayLoading(false);
        errorSubs.unsubscribe();
        subs.unsubscribe();
      });
    subs = this.utilities.actions
      .pipe(ofActionSuccessful(action))
      .subscribe(() => {
        this._dataService.displayLoading(false);
        errorSubs.unsubscribe();
        subs.unsubscribe();
      });
  };

  removeSearchCriteria = (event, id) => {
    this._dataService.displayLoading();
    event.stopImmediatePropagation();
    event.preventDefault();
    this.utilities.store.dispatch(new DeleteSearchCriteriaUser(id));
    this.handler(DeleteSearchCriteriaUser);
  };
}
